import Vue from 'vue';
import addressTransformer from './../../transformers/address';
import find from './show';

// When the request succeeds
const success = (resolve) => {
  find();
  resolve();
};

// When the request fails
const failed = (error, reject) => {
  reject(addressTransformer.fetch(error.response.data));
};

export default (address) => {
  const p = new Promise((resolve, reject) => {
    Vue.$http.put('/addresses', address)
    .then(() => {
      success(resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  });
  return p;
};



// WEBPACK FOOTER //
// ./src/app/services/address/update.js